import { useQuery } from "@connectrpc/connect-query";
import type { GetRadiusRequest } from "../../../api/provider-network/provider/v1/provider_pb";
import { StaleTime } from "../types";
import { getRadius } from "../../../api/provider-network/provider/v1/provider-Service_connectquery";
import { useMctFlags } from "../../flag-hooks/useMctFlags";
import { useAppState } from "../../context-hooks/useAppState";
import { useMemo } from "react";

export const useGetRadius = (
  request?: Partial<Omit<GetRadiusRequest, "$typeName">>
) => {
  // * Flags
  const { tmpFeEnableProviderNetwork } = useMctFlags();

  // * Context
  const { zipcode: stateZip } = useAppState();
  const zipCode = request?.zipCode ?? stateZip ?? "";

  const requestPayload: GetRadiusRequest = useMemo(
    () => ({
      $typeName: "provider.v1.GetRadiusRequest",
      zipCode,
      planInfo: request?.planInfo,
    }),
    [request?.planInfo, zipCode]
  );

  // * Queries
  const {
    isLoading,
    isError,
    error,
    data: radiusData,
  } = useQuery(getRadius, requestPayload, {
    staleTime: StaleTime.Infinite,
    enabled: !!zipCode && tmpFeEnableProviderNetwork,
  });

  return {
    radiusData,
    isLoading,
    isError,
    error,
  };
};
